import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";
import { getUserEffectivePermissions } from "../api/rbac-api";
import type { UserEffectivePermissions } from "../types/RolesPermissions.type";

export const USER_EFFECTIVE_PERMISSIONS_KEYS = {
	all: ["rbac", "user-permissions"] as const,
	byUser: (userId: number) => [...USER_EFFECTIVE_PERMISSIONS_KEYS.all, userId] as const,
};

/**
 * PRO-413 #UM1 — a user's server-authoritative effective standing permissions
 * for the read-only access matrix. `enabled` gates the request so the modal
 * only fetches when a user is actually selected (the modal is unmounted
 * otherwise, but this also guards the transient `undefined` userId).
 */
export const useUserEffectivePermissions = (
	userId: number | undefined
): UseQueryResult<UserEffectivePermissions> => {
	return useQuery({
		queryKey: USER_EFFECTIVE_PERMISSIONS_KEYS.byUser(userId as number),
		queryFn: () => getUserEffectivePermissions(userId as number),
		enabled: typeof userId === "number",
	});
};
